import { configureStore } from '@reduxjs/toolkit';

import api from '@api/index';
import apiComuni from '@api/locations.api';

import authSlice from '@slices/auth.slice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    [api.reducerPath]: api.reducer,
    [apiComuni.reducerPath]: apiComuni.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['api.queries.getMedicalDoctorsXlsx'],
      },
    }).concat(api.middleware, apiComuni.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
